import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
export function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const isExpired = timeLeft <= 0;
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-brand-orange to-orange-600 text-white shadow-md" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm sm:text-base font-medium" data-id="element-11">
        <div className="flex items-center gap-2" data-id="element-12">
          <FlameIcon className="w-5 h-5 text-yellow-300 animate-pulse" data-id="element-13" />
          <span data-id="element-14">🔥 El descuento del 67% termina en:</span>
        </div>

        {isExpired ? <span className="font-bold text-yellow-200 tracking-wider" data-id="element-15">
            ¡Oferta expirada!
          </span> : <div className="flex items-center gap-3" data-id="element-16">
            <span className="font-mono font-bold text-lg bg-black/20 px-2 py-0.5 rounded" data-id="element-17">
              {String(minutes).padStart(2, '0')}:
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="font-bold text-yellow-200 animate-pulse" data-id="element-18">
              ¡Aprovecha ahora!
            </span>
          </div>}
      </div>
    </div>;
}